import AverageNumberOfVisitsPerClientModule from "./averageNumberOfVisitsPerClientModule";
import AverageNumberOfVisitsPerClientReducer from "./redux/averageNumberOfVisitsPerClientReducer";
import AverageNumberOfVisitsPerClientSaga from "./redux/averageNumberOfVisitsPerClientSagas";

export default {
  Component: AverageNumberOfVisitsPerClientModule,
  moduleName: "averageNumberOfVisitsPerClient",
  saga: AverageNumberOfVisitsPerClientSaga(),
  reducer: AverageNumberOfVisitsPerClientReducer
};
